/**
 * @generated SignedSource<<e721e0997a9167422dfb3e0819094233>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobEventActorType = "AGENT" | "DISPATCH" | "STACK" | "SYSTEM" | "USER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobEventAssigned_event$data = {
  readonly actor: {
    readonly type: JobEventActorType;
  };
  readonly assignedAgent?: {
    readonly " $fragmentSpreads": FragmentRefs<"AgentBadge_agent">;
  } | null;
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventAssigned_event";
};
export type JobEventAssigned_event$key = {
  readonly " $data"?: JobEventAssigned_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventAssigned_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAssigned_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agent",
          "kind": "LinkedField",
          "name": "assignedAgent",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "JobEventAssigned",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobEventActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "59bbaf13e91dc590c4fc938386cd36b6";

export default node;
